import {
  FETCH_DISCOUNTS_DATA,
  FETCH_DISCOUNTS_SUCCESS,
  FETCH_DISCOUNTS_FAILURE,
  FETCH_DISCOUNTS_EDIT_DATA,
  FETCH_DISCOUNTS_EDIT_SUCCESS,
  FETCH_DISCOUNTS_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const Discounts = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISCOUNTS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_DISCOUNTS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_DISCOUNTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_DISCOUNTS_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_DISCOUNTS_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_DISCOUNTS_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default Discounts;
